import { shallowMount } from "@vue/test-utils";
import OtpInput from "@/components/core/OtpInput";

describe("OtpInput Component mount", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OtpInput, {
      props: {
        value: "value",
        name: "name",
        maxlength: 5,
        validationError: ""
      }
    });
  });

  it("Renders del component OtpInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
